
import React from 'react';
import LazyImageComponent from './LazyImageComponent';
import "./Playlist.css";

export default function Gallery(props) {
  const { playlist, onTrackClick } = props;

  return (
    <section className='playlist'>
      <div onClick={() => onTrackClick(playlist)}>
        <LazyImageComponent
          imageUrl={playlist.imageUrl}
          alt={playlist.name}
          className="playlistposter"
        />
      </div>
    </section>
  );
}





